import React from 'react';
import {
    TransformWrapper,
    TransformComponent,
    useControls,
} from "react-zoom-pan-pinch";

export default function ImageViewer({imageUrl}) {
    return (
        <div>
            <TransformWrapper
                smooth={false}
            >
                <TransformComponent
                    contentStyle={{width: '100%'}}
                >
                    <img src={imageUrl} alt="instruction" style={{ width: '100%'}} />
                </TransformComponent>
            </TransformWrapper>
        </div>
    );
}